import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule  } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './pages/home/home.component';
import { LandingComponent } from './pages/landing/landing.component';
import { AuthGuard } from './auth.guard';

const routes: Routes =[
  { path: 'home', component: HomeComponent },
  { path: 'login', loadChildren: '../app/pages/login/login.module#LoginModule'},
  { path: 'perfil/:id/ativacao/:idAtivacao', loadChildren: '../app/pages/profile/profile.module#ProfileModule'},
  { path: 'perfil/:id', loadChildren: '../app/pages/profile/profile.module#ProfileModule'},
  { path: 'painel/:id' , loadChildren: '../app/pages/presentation/presentation.module#PresentationModule'},
  { path: 'gestao/:id', loadChildren: '../app/pages/deceased-manager/deceased-manager.module#DeceasedManagerModule', canActivate: [AuthGuard]},
  // { path: 'gestao', loadChildren: '../app/pages/deceased-manager/deceased-manager.module#DeceasedManagerModule', canActivate: [AuthGuard]},
  { path: 'administrador', loadChildren: '../app/pages/admin/admin.module#AdminModule', canActivate: [AuthGuard]},
  { path: 'list', loadChildren: '../app/pages/deceased-list/deceased-list.module#DeceasedListModule', canActivate: [AuthGuard]},
  { path: 'landing',          component: LandingComponent },
  // { path: 'nucleoicons',      component: NucleoiconsComponent },
  { path: '', redirectTo: 'home', pathMatch: 'full' }
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes)
  ],
  exports: [
  ],
})
export class AppRoutingModule { }
